// extracted by mini-css-extract-plugin
export default {"fullscreen-carousel":"MediaReleasesAds_fullscreen-carousel__6Nq+7","play":"MediaReleasesAds_play__C-4R5","slick-slider":"MediaReleasesAds_slick-slider__Oc8AC"};